var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.pulseHost.$invalid
          }
        },
        [
          _c("label", [_vm._v("Pulse Host")]),
          _c("md-input", {
            model: {
              value: _vm.ooyalaParams.pulseHost,
              callback: function($$v) {
                _vm.$set(_vm.ooyalaParams, "pulseHost", $$v)
              },
              expression: "ooyalaParams.pulseHost"
            }
          }),
          _vm.formSubmitted && !_vm.validations.pulseHost.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e(),
          _vm.formSubmitted && !_vm.validations.pulseHost.url
            ? _c("span", { staticClass: "md-error" }, [_vm._v("Invalid URL")])
            : _vm._e()
        ],
        1
      ),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.category.$invalid
          }
        },
        [
          _c("label", [_vm._v("Category")]),
          _c("md-input", {
            model: {
              value: _vm.ooyalaParams.category,
              callback: function($$v) {
                _vm.$set(_vm.ooyalaParams, "category", $$v)
              },
              expression: "ooyalaParams.category"
            }
          }),
          _vm.formSubmitted && !_vm.validations.category.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a74abf2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a74abf2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Ooyala.vue
// module id = 783
// module chunks = 0